@if (data) {
  <div class="track-order relative mt-[30px] mb-[15px]">
    <div
      class="absolute md:h-[10px] md:w-auto w-[10px] bg-[#DFDFDF] md:top-[55px] md:left-[10%] md:right-[10%] md:mt-[10px] z-[1] left-[56px] top-[30px] bottom-[40px]"
    >
      <!-- Horizontal on desktop (width grows) -->
      <div
        class="hidden md:block md:h-[10px] w-[10px] bg-[#3BB000]"
        [style.width.%]="getProgressPercentage(data)"
      ></div>

      <!-- Vertical on mobile (height grows) -->
      <div
        class="block md:hidden md:w-[10px] w-[10px] bg-[#3BB000]"
        [style.height.%]="getProgressPercentage(data)"
      ></div>
    </div>

    <div class="grid md:grid-cols-5 md:gap-[10px] gap-[20px] relative z-[2]">
      @for (trackerStep of data.trackerSteps; track trackerStep) {
        <div class="flex md:flex-col items-center md:text-center gap-[10px]">
          <div class="flex-shrink-0">
            <img
              [src]="trackerStep.imageUrl"
              alt="tracker step"
              class="w-[38px] h-[38px] object-contain m-auto"
            />
          </div>
          <div class="flex-shrink-0 mt-[2px]">
            @if (trackerStep?.completed) {
              <img
                [src]="data.images.completedStepImageUrl"
                alt="completed step"
                class="w-[25px] h-[25px] object-contain m-auto"
              />
            } @else {
              <img
                [src]="data.images.stepImageUrl"
                alt="incomplete step"
                class="w-[25px] h-[25px] object-contain m-auto"
              />
            }
          </div>
          <div class="grow">
            <div class="text-[15px] font-semibold text-[#000000]">
              {{ StringUtils.capitalizeFirstLetter(trackerStep?.title) }}
            </div>
            @if (trackerStep?.subtitle) {
              <div class="text-[14px] text-[#5B5B5B]">
                {{ trackerStep?.subtitle }}
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (data?.paymentMode) {
      <div class="flex items-end">
        <div class="text-[14px] text-[#5B5B5B]">{{ data.paymentMode }}</div>
      </div>
    }
  </div>
}
